import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cramo-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
